import React from "react";
import { Pagination as BootstrapPagination } from "react-bootstrap";
import { useLocalization } from "../../../context/LocalizeContextProvider";
import SelectField from "../SelectField";
import styles from "./Pagination.module.css";

const Pagination = ({
  activePage = 0,
  totalPage = 0,
  totalShow = 0,
  totalEntries = 0,
  handlePagination = () => undefined,
  handleSizePerPage = () => undefined,
  sizePerPage = 50,
  showSizeOptions = true,
}) => {
  const localize = useLocalization();

  const showingStart =
    totalShow !== 0 ? (activePage === 0 ? 1 : activePage * sizePerPage + 1) : 0;
  const showingOfEntries = totalShow !== 0 ? showingStart + totalShow - 1 : 0;

  // Generate pagination items
  const generatePaginationItems = () => {
    let items = [];

    // Add pagination numbers
    for (let number = 1; number <= totalPage; number++) {
      if (
        number !== totalPage &&
        number <= activePage + 4 &&
        number >= activePage - 2
      ) {
        items.push(
          <BootstrapPagination.Item
            key={number}
            active={number - 1 === activePage}
            onClick={() => handlePagePagination(number - 1)}
          >
            {number}
          </BootstrapPagination.Item>
        );
      }
    }

    // Add last page with ellipsis if needed
    if (totalPage > 0) {
      if (activePage + 4 < totalPage) {
        items.push(<BootstrapPagination.Ellipsis key="ellipsis" />);
      }

      items.push(
        <BootstrapPagination.Item
          key={totalPage}
          active={totalPage - 1 === activePage}
          onClick={() => handlePagePagination(totalPage - 1)}
        >
          {totalPage}
        </BootstrapPagination.Item>
      );
    }

    return items;
  };

  const handlePagePagination = (number) => {
    handlePagination(number);
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  if (totalEntries === 0) return null;

  return (
    <div className={styles.container}>
      <p className={styles.entriesText}>
        {localize.getText("ShowingOfEntries", {
          totalShow: showingStart,
          totalShowOfEntries: showingOfEntries,
          totalEntries: totalEntries,
        })}
      </p>
      <div className={styles.paginationWrapper}>
        <BootstrapPagination>
          {totalPage >= 20 && (
            <BootstrapPagination.First
              onClick={() => handlePagePagination(0)}
            />
          )}

          {activePage > 0 && (
            <BootstrapPagination.Prev
              onClick={() =>
                activePage >= 0 && handlePagePagination(activePage - 1)
              }
            />
          )}

          {generatePaginationItems()}

          {activePage + 1 < totalPage && (
            <>
              <BootstrapPagination.Next
                onClick={() =>
                  activePage >= 0 && handlePagePagination(activePage + 1)
                }
              />
              {totalPage >= 20 && (
                <BootstrapPagination.Last
                  onClick={() => handlePagePagination(totalPage - 1)}
                />
              )}
            </>
          )}
        </BootstrapPagination>

        {showSizeOptions && (
          <SelectField
            placeholder={localize.getText("entriesPerPage")}
            data={[
              { value: 5, label: 5 },
              { value: 10, label: 10 },
              { value: 50, label: 50 },
              { value: 100, label: 100 },
              { value: 200, label: 200 },
              { value: 300, label: 300 },
              { value: 400, label: 400 },
              { value: 500, label: 500 },
            ]}
            onChange={(value) => handleSizePerPage(value)}
            value={sizePerPage}
            style={{ width: 70 }}
            isBorder
          />
        )}
      </div>
    </div>
  );
};

export default Pagination;
